












import { Vue, Prop, Component } from 'vue-property-decorator'
@Component
export default class ChannelItem2 extends Vue {
  @Prop() item
  @Prop() hasBought
}
